import React from "react";
import { GlobalContainer } from "../../../Global/layout";
import { CaseStudySection, ColContainer, RowContainer, Title } from "./style";
import theme from "../../../../theme";
import { Carousel, Col } from "antd";

const CaseStudy = ({ data }: any) => {
  return (
    <section className="dark">
      <CaseStudySection color={theme.black}>
        <GlobalContainer>
          <Title style={{ color: "white" }} data-aos="fade-up">
            {data?.heading}
          </Title>

          <Carousel arrows>
            {data?.servicesCta?.map((item: any, index: number) => {
              return (
                <RowContainer gutter={65} key={index} data-aos="fade-up">
                  <ColContainer xs={24} sm={24} md={12} lg={12} xl={12}>
                    <h2 dangerouslySetInnerHTML={{__html: item.heading}} />
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    <p>{item.serviceText}</p>
                    <h4>Platform</h4>

                    <img
                      src={item.platformImage?.mediaItemUrl}
                      alt={item.platformImage?.altText}
                    />
                  </ColContainer>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <img
                      src={item.image?.mediaItemUrl}
                      alt={item.image?.altText}
                    />
                  </Col>
                </RowContainer>
              );
            })}
          </Carousel>
        </GlobalContainer>
      </CaseStudySection>
    </section>
  );
};

export default CaseStudy;
